<template>
		<div v-if="enablePageLength">
			<select class="custom-select ml-1 mt-1"  v-model="basePerPage">
					<option :value="option.value" :key="option.value" v-for="(option) in perPageOptions">{{  option.text }} </option>
			</select>
		</div>
</template>
  
<script>
	export default {
		name: 'o-pagelength',
		data: () => ({
			basePerPage: 20,
			perPageOptions: []
		}),
		created() {
			this.perPageOptions = [
				{'text': 20, 'value': 20},
				{'text': 50, 'value': 50},
				{'text': 100, 'value': 100},
				{'text': 250, 'value': 250},
				{'text': 500, 'value': 500}
			]
		}, 
		watch: {
			basePerPage(newVal, oldVal) {
				if (newVal !== oldVal) {
					console.log("new", newVal)
					this.$emit('set-record-length', newVal)
				}
			}
		}, 
		props: {
			enablePageLength : {
					type: Boolean,
					default: false
			}
		}
	}
</script>
  